"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAttributeElementsPageSaga = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var loadInitialElementsPageSaga_1 = require("../loadInitialElementsPage/loadInitialElementsPageSaga");
var slice_1 = require("../store/slice");
/**
 * @internal
 */
function initAttributeElementsPageSaga(correlation) {
    var error;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.fork(loadInitialElementsPageSaga_1.loadInitialElementsPageSaga, slice_1.actions.loadInitialElementsPageRequest({ correlation: correlation }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.race({
                        success: effects_1.take(function (a) {
                            return slice_1.actions.loadInitialElementsPageSuccess.match(a) && a.payload.correlation === correlation;
                        }),
                        error: effects_1.take(function (a) {
                            return slice_1.actions.loadInitialElementsPageError.match(a) && a.payload.correlation === correlation;
                        }),
                        cancel: effects_1.take(function (a) {
                            return slice_1.actions.loadInitialElementsPageCancel.match(a) && a.payload.correlation === correlation;
                        }),
                    })];
            case 2:
                error = (_a.sent()).error;
                if (error) {
                    throw error.payload.error;
                }
                return [2 /*return*/];
        }
    });
}
exports.initAttributeElementsPageSaga = initAttributeElementsPageSaga;
//# sourceMappingURL=initElementsPageSaga.js.map